import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import PropTypes from 'prop-types';
import { handleRipple } from '../../../../helpers/ripple';
import {
  IconButton,
  LockScroll,
  NavbarSection,
  NavbarList,
  NavbarLink,
  SubNavbarLink,
  LoginButton,
  BitcoinLogo,
} from './styled';

const Menu = ({ isOpen, onClick, navbarList, buttonData }) => {
  const handleButtonClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <>
      <IconButton onClick={handleButtonClick}>
        {isOpen ? (
          <IoMdClose size={40} color="#1c1c1c" />
        ) : (
          <GiHamburgerMenu size={40} color="#1c1c1c" />
        )}
      </IconButton>
      <LockScroll locked={isOpen} />
      <NavbarSection open={isOpen}>
        <NavbarList>
          {navbarList.map(item => (
            <React.Fragment key={item.key}>
              <NavbarLink
                href={item.link}
                target={item.openNewTab ? '_blank' : undefined}
              >
                {item.text}
              </NavbarLink>
              {item.submenu && item.submenu.map(sub => (
                <SubNavbarLink
                  key={sub.key}
                  href={sub.link}
                  target={sub.openNewTab ? '_blank' : undefined}
                >
                  {sub.text}
                </SubNavbarLink>
              ))}
            </React.Fragment>
          ))}
        </NavbarList>
        <LoginButton
          href={buttonData.buttonLink}
          target="_blank"
          onMouseEnter={handleRipple}
        >
          <BitcoinLogo
            src="/images/uploads/home/floating-button-icon.png"
            alt="bitcoin logo"
          />
          {buttonData.buttonText}
        </LoginButton>
      </NavbarSection>
    </>
  );
};

Menu.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  navbarList: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.string,
      openNewTab: PropTypes.bool,
    }),
  ),
  buttonData: PropTypes.shape({
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
  }),
}.isRequired;

export default Menu;
